<template>
  <div>
    <KTCard>
      <template v-slot:title>
        <h3 class="mb-4">
          {{ $t("LABELS.ADD_NEW") }} {{ $t("MENU.ITEM.EXP.AI_COMPANIES") }}
        </h3>
      </template>
      <template v-slot:body>
        <AiCompanyForm :form="form" :errors="errors" :$v="$v" @submit="onSave">
          <template #actions>
            <div class="mt-4">
              <BackButton />
              <SaveButtonDropdown
                :defaultAction="'continue'"
                :isLoading="isLoadingAiCompany"
                v-on:save="onSave($event)"
              />
            </div>
          </template>
        </AiCompanyForm>
      </template>
      <template v-slot:foot>
        <div v-show="errors.length" class="alert alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SAVE_AI_COMPANY } from "../store/ai-companies.module";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { formBuilderMixin } from "@/core/mixins/formBuilderMixin.js";
import KTCard from "@/view/content/Card.vue";
import AiCompanyForm from "../components/AiCompanyForm.vue";
import SaveButtonDropdown from "@/view/content/forms/components/SaveButtonDropdown.vue";
import { mapGetters } from "vuex";

export default {
  mixins: [validationMixin, formBuilderMixin],
  data() {
    return {
      errors: [],
      form: {
        name: "",
        bulstat: "",
        vatNumber: "",
        molNumber: "",
        address: "",
        isConfirmed: false,
        isBuyer: false
      }
    };
  },
  components: {
    KTCard,
    AiCompanyForm,
    SaveButtonDropdown
  },
  computed: {
    ...mapGetters(["isLoadingAiCompany"])
  },
  validations() {
    return {
      form: {
        name: { required },
        bulstat: { required },
        vatNumber: { required },
        molNumber: { required },
        address: { required },
        isConfirmed: { required },
        isBuyer: { required }
      }
    };
  },
  methods: {
    onSave(next) {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.errors = ["Please fill all required fields correctly"];
        return;
      }
      this.$store
        .dispatch(SAVE_AI_COMPANY, this.form)
        .then(data => {
          this.$router.push({ name: "list-ai-companies" });
        })
        .catch(response => {
          this.errors = response.data.errors || [response.data.message];
        });
    }
  }
};
</script>
